const AddressType = Object.freeze({
    NONE: 'NONE',
    REGISTERED: 'REGISTERED',
    MAIL: 'MAIL',
    BILL: 'BILL'
});

export default AddressType;
